export default __webpack_public_path__ + "static/media/aws-quicksight.bb6343c6.svg";